module.exports = __webpack_public_path__ + "media/images/errors/500-e1d0338148a54b16968e6b64593bd1b3.png";